import React, { useCallback } from 'react'
import { Input } from 'antd'
import { subWatermarkText } from '../../../../utils/utils'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import { setEditorWatermark } from '../../../../actions/watermark'
import { PRESET_ITEM_MAX_CHAR_LENGTH } from '../../../../constants/watermark'
import {
  CaretDownOutlined,
  CaretUpOutlined,
  CloseOutlined
} from '@ant-design/icons'

interface PresetItemProps {
  index: number
  contentItemIndex: number
  contentItem: string
}

const PresetItem: React.FC<PresetItemProps> = (props) => {
  const { index, contentItemIndex, contentItem } = props
  const watermark = useAppSelector((state) => state.editor.watermark)
  const dispatch = useAppDispatch()
  const onChange = (newWatermark) => dispatch(setEditorWatermark(newWatermark))

  const itemsList = watermark?.items?.[index]?.contentEdit?.itemsList || []

  const onContentChange = useCallback(
    (e) => {
      const newItemsList = itemsList.map((item, idx) =>
        idx === contentItemIndex
          ? subWatermarkText(e.target.value, PRESET_ITEM_MAX_CHAR_LENGTH / 2)
          : item
      )
      const newItems = watermark.items.map((it, idx) =>
        idx === index
          ? {
              ...it,
              contentEdit: {
                ...it.contentEdit,
                itemsList: newItemsList
              }
            }
          : it
      )
      onChange({ ...watermark, items: newItems })
    },
    [watermark, itemsList, contentItemIndex, index]
  )

  const onMoveUp = useCallback(() => {
    //上移一位
    if (contentItemIndex > 0) {
      const newItemsList = [...itemsList]
      const temp = newItemsList[contentItemIndex - 1]
      newItemsList[contentItemIndex - 1] = newItemsList[contentItemIndex]
      newItemsList[contentItemIndex] = temp
      const newItems = watermark.items.map((it, idx) =>
        idx === index
          ? {
              ...it,
              contentEdit: {
                ...it.contentEdit,
                itemsList: newItemsList
              }
            }
          : it
      )
      onChange({ ...watermark, items: newItems })
    }
  }, [watermark, itemsList, index, contentItemIndex])

  const onMoveDown = useCallback(() => {
    //下移一位
    if (contentItemIndex < itemsList.length - 1) {
      const newItemsList = [...itemsList]
      const temp = newItemsList[contentItemIndex + 1]
      newItemsList[contentItemIndex + 1] = newItemsList[contentItemIndex]
      newItemsList[contentItemIndex] = temp
      const newItems = watermark.items.map((it, idx) =>
        idx === index
          ? {
              ...it,
              contentEdit: {
                ...it.contentEdit,
                itemsList: newItemsList
              }
            }
          : it
      )
      onChange({ ...watermark, items: newItems })
    }
  }, [watermark, itemsList, index, contentItemIndex])

  const onDelete = useCallback(() => {
    const newItemsList = itemsList.filter((_, idx) => idx !== contentItemIndex)
    const newItems = watermark.items.map((it, idx) =>
      idx === index
        ? {
            ...it,
            contentEdit: {
              ...it.contentEdit,
              itemsList: newItemsList
            }
          }
        : it
    )
    onChange({ ...watermark, items: newItems })
  }, [watermark, itemsList, index, contentItemIndex])

  return (
    <div className="preset-item">
      <Input
        value={contentItem}
        placeholder="请输入..."
        onChange={onContentChange}
      />
      <span
        style={contentItemIndex === 0 ? { color: '#D9D9D9' } : {}}
        onClick={onMoveUp}
      >
        <CaretUpOutlined />
      </span>
      <span
        style={
          contentItemIndex === itemsList.length - 1 ? { color: '#D9D9D9' } : {}
        }
        onClick={onMoveDown}
      >
        <CaretDownOutlined />
      </span>
      {itemsList.length > 1 && (
        <span onClick={onDelete}>
          <CloseOutlined />
        </span>
      )}
    </div>
  )
}

export default PresetItem
